import Aanpak from './aanpak';
import Accordion from './accordion';
import ApproachSlider from './approach-slider';
import ArticlesLoadMore from './articles-load-more';
import CustomCursor from './custom-cursor';
import FormieEvents from './formie-events';
import HeroMain from './hero-main';
import Logo from './logo';
import Menu from './menu';
import MorphImages from './morph-images';
import Process from './process';
import Projects from './projects';
import HoverImage from './projects/hover-image';
import MobileInfo from './projects/mobile-info';
import Reframe from './reframe';
import SectionFade from './section-fade';
import Sentry from './sentry';
import ProjectsSlider from './sliders/projects-slider';
import StickyNav from './sticky-nav';
import LangSwitch from './sticky-nav/lang-switch';
import StudioModal from './studio-modal';

export default [
  Sentry,
  Reframe,
  Logo,
  Accordion,
  ArticlesLoadMore,
  ApproachSlider,
  Process,
  ProjectsSlider,
  Projects,
  HoverImage,
  StickyNav,
  Aanpak,
  FormieEvents,
  Menu,
  MobileInfo,
  LangSwitch,
  MorphImages,
  SectionFade,
  HeroMain,
  StudioModal,
  CustomCursor,
];
